<template>
	<div :class="['news-item', 'news-' + type]">
		<!-- <news-img v-if="type === 'img'" :item="item"></news-img> -->
		<news-normal  :item="item"></news-normal>
	</div>
</template>

<script>
import NewsNormal from './news-normal'
import NewsImg from './news-img'

export default {
	components: {
		NewsNormal,
		NewsImg
	},
	props: ['item'],
	computed: {
		type() {
			
			const viewType = this.item.viewType;
			const type = this.item.type;
			// if(viewType == "banner" && type == "image"){
			// 	return "img";
			// }
			//if(viewType == "normal" type="")
			// if(type.indexOf("image") >= 0) {
			// 	return "img";
			// }
			return "normal";
		}
	}	
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
	@import '~src/styles/page-topic.styl';
	@import '~src/styles/news-stream.styl';
</style>


// WEBPACK FOOTER //
// news-item.vue?57dfe8a6